import "./jumbotron.scss";

export default function Jumbotron({ message = "No Data" }) {
  return (
    <div className="jumbotron">
      <p>{message}</p>
    </div>
  );
}
